import { AnalyticsScreenProvider, PrimarySecondaryPage } from "@wayflyer/flyui";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { useIntl } from "react-intl";
import { OnboardingStepper } from "onboarding";
import { useCustomerAppConfig } from "undercarriage";

import { ConnectionsSidePanel } from "../../components";
import { getFundingApplicationStagesQueryOptions } from "../../queries/funding-application-configuration/queries";

import { BankController } from "./bank-connect-controller";
import { BankingNextPage } from "./banking-next";

export const BankingPage = () => {
  const intl = useIntl();
  const isNewOnboardingSetupFlowEnabled = useFeatureFlagEnabled("enable_new_onboarding_setup_flow");
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { data: fundingApplicationStages } = useSuspenseQuery(getFundingApplicationStagesQueryOptions(customerDomain));
  const requireConnection = fundingApplicationStages.banking?.requireConnection === true;

  if (isNewOnboardingSetupFlowEnabled) {
    return <BankingNextPage />;
  }

  return (
    <AnalyticsScreenProvider screen="onboarding-banking">
      <PrimarySecondaryPage
        titleSlot={<OnboardingStepper currentStep={4} />}
        showStepperBackground={true}
        title={intl.formatMessage({
          id: "funding_application: banking page header",
          defaultMessage: "Connect bank accounts",
        })}
        primaryContent={<BankController requireConnection={requireConnection} />}
        secondaryContent={<ConnectionsSidePanel />}
      />
    </AnalyticsScreenProvider>
  );
};
